import { render } from "./icon-pulse.svg?vue&type=template&id=f49a119f&scoped=true&component"
const script = {  }

import "./icon-pulse.svg?vue&type=style&index=0&id=f49a119f&scoped=true&lang=css&component"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f49a119f"]])

export default __exports__